var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoint({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0909 6.54545C13.0909 11.6364 6.54545 16 6.54545 16C6.54545 16 0 11.6364 0 6.54545C2.58679e-08 4.80949 0.689608 3.14463 1.91712 1.91712C3.14463 0.689608 4.80949 0 6.54545 0C8.28142 0 9.94628 0.689608 11.1738 1.91712C12.4013 3.14463 13.0909 4.80949 13.0909 6.54545Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54534 8.72741C7.75033 8.72741 8.72716 7.75057 8.72716 6.54559C8.72716 5.3406 7.75033 4.36377 6.54534 4.36377C5.34036 4.36377 4.36353 5.3406 4.36353 6.54559C4.36353 7.75057 5.34036 8.72741 6.54534 8.72741Z",
    fill: "#444348"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint);
export default __webpack_public_path__ + "static/media/point.4a3be56f5fce04f6a98b18efd2fc4ec9.svg";
export { ForwardRef as ReactComponent };